<template>
  <form id="search" name="search" class="search-form">
    <div class="search-form__image" @click.stop.prevent="onSearch">
      <img src="~~/assets/icons/search.svg" alt="search" />
    </div>
    <input
      v-show="focusedInput"
      ref="inputSearchRef"
      v-model="inputValue"
      type="text"
      class="search-form__input"
      @blur="onBlur"
    />
    <Typewriter
      v-show="!focusedInput"
      :key="langStore.language.name"
      class="search-form__input typewriter"
      :strings="typewriterPrompt"
      @click="focusInput"
    />
    <input
      type="submit"
      class="button-primary"
      :value="_T('@Search')"
      @click.stop.prevent="onSearch"
    />
  </form>
</template>

<script setup>
import { useLanguageStore } from "~/store/languageStore.js";
import Typewriter from "~/modules/shared/typewriter/Typewriter.vue";

const inputValue = ref("");
const inputSearchRef = ref(null);
const focusedInput = ref(false);
const langStore = useLanguageStore();

const typewriterPrompt = computed(() => {
  const prompts = [
    {
      ru: "Аккумулятор",
      uk: "Акумулятор",
    },
    {
      ru: "ИБП",
      uk: "ДБЖ",
    },
    {
      ru: "Стабилизатор",
      uk: "Стабілізатор",
    },
    {
      ru: "Autonomic",
      uk: "Autonomic",
    },
    {
      ru: "Альтернативная энергетика",
      uk: "Альтернативна енергетика",
    },
  ];

  return prompts.map((prompt) => getLocalizedName(prompt));
});

const focusInput = async () => {
  focusedInput.value = true;

  await nextTick();
  inputSearchRef.value.focus();
};

const onBlur = () => {
  if (0 === inputValue.value.trim().length) {
    focusedInput.value = false;
  }
};

const onSearch = () => {
  if (0 !== inputValue.value.trim().length) {
    return navigateTo({
      name: getLocalizedRouteName("search"),
      query: { searchQuery: inputValue.value.trim() },
    });
  }
};
</script>

<style lang="scss" scoped>
.search-form {
  max-width: 700px;
  width: 100%;

  position: relative;

  @include flex-container(row, center, center);

  overflow: hidden;
  white-space: nowrap;

  &__image {
    position: absolute;
    left: 8px;
  }

  &__input {
    width: 100%;

    @include font(16, 22);
    letter-spacing: 0.02em;

    background-color: white;

    border-radius: 30px;

    padding: 8px 100px 8px 40px;

    cursor: text;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;

      margin: 0;
    }

    &::placeholder {
      @include font(16, 22);
    }

    &.typewriter {
      color: var(--color-sky-darker);
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.button-primary {
  width: max-content;

  position: absolute;
  right: 0;

  line-height: 20px;

  padding-inline: 16px;

  @include bigMobile {
    height: 0;
    width: 0;

    opacity: 0;
    visibility: hidden;

    padding: 0;
  }
}
</style>
